export default "__VITE_ASSET__C8rwi3Xg__"